import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppFeatureStateService {
  private allowedFeatures = new Set<string>();
  private loaded = false;

  setPermissions(featureKeys: string[]): void {
    this.allowedFeatures = new Set(featureKeys);
    this.loaded = true;
  }

  canView(featureKey: string): boolean {
    if (!this.loaded) return false;
    return this.allowedFeatures.has(featureKey);
  }

  isLoaded(): boolean {
    return this.loaded;
  }

  reset(): void {
    this.allowedFeatures.clear();
    this.loaded = false;
  }
}
